import React from 'react';
import ReportViewer from "./base/ReportViewer";

const NombreNuiteesAnnuelTypeUnite = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"NombreNuiteesAnnuelParTypeUnitesReport"} />
        </div>
    );
}
export default NombreNuiteesAnnuelTypeUnite;